// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"8810441e","513":"53c515ee"}[chunkId] + ".chunk.js";
};